export default "__VITE_ASSET__4tyS9iAn__"